import { ref } from "vue"

export const sideNavActive = ref(false)

export function toggleSideNav() {
    sideNavActive.value = !sideNavActive.value
}